/* Candela apparel cards — colour swatch switching (candela-card-product.liquid, apparel mode).
   Event delegation, so cards added by infinite scroll and sliders work too.
   Switching a colour: shows that colour's image pair, updates the colour name,
   greys out sizes that are sold out in that colour, and points the card links
   and quick-add at that colour's variant. */

(function () {
  function parseAvailability(str) {
    var map = {};
    (str || '').split(';').forEach(function (entry) {
      if (!entry) return;
      var parts = entry.split(':');
      var key = parts[0].split('|');
      var color = key[0], size = key[1];
      if (!map[color]) map[color] = {};
      map[color][size] = parts[1] === 'true';
    });
    return map;
  }

  function withVariant(url, variantId) {
    var base = url.split('?')[0];
    return variantId ? base + '?variant=' + variantId : base;
  }

  function select(card, color) {
    var media = card.querySelector('.candela-card__color-media[data-color="' + CSS.escape(color) + '"]');
    if (!media) return;

    card.dataset.color = color;

    card.querySelectorAll('.candela-card__color-media').forEach(function (el) {
      el.classList.toggle('is-active', el === media);
    });

    card.querySelectorAll('.candela-card__swatch').forEach(function (btn) {
      var active = btn.dataset.color === color;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var name = card.querySelector('.candela-card__color-name');
    if (name) name.textContent = color;

    var availability = parseAvailability(card.dataset.availability)[color] || {};
    card.querySelectorAll('.candela-card__size').forEach(function (li) {
      li.classList.toggle('is-soldout', !availability[li.dataset.size]);
    });

    var url = withVariant(card.dataset.productUrl || '', media.dataset.variantId);
    card.querySelectorAll('[data-href]').forEach(function (el) { el.dataset.href = url; });
    var hidden = card.querySelector('a.visually-hidden');
    if (hidden) hidden.setAttribute('href', url);

    var quickAdd = card.querySelector('.candela-card__quick-add-btn');
    if (quickAdd) quickAdd.dataset.color = color;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.candela-card__swatch');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('.candela-card');
    if (card) select(card, btn.dataset.color);
  });

  window.CandelaApparelCard = { select: select };
})();
